import React from 'react';
import styled from 'styled-components';

import { formatBigNumber, formatLikes } from '../../../helpers';

const Info = styled.div`
  padding-top: 10px;
  font-family: BrandonGrotesque-Regular;
  font-size: 14px;
  line-height: 1.21;
  letter-spacing: 0.7px;
  color: #333333;
`;

const Link = styled.a`
  padding-top: 10px;
  font-family: BrandonGrotesque-Regular;
  font-size: 14px;
  line-height: 1.21;
  letter-spacing: 0.7px;
  color: #333333;
  text-decoration: underline;
`;

function SnapshotInfo(props: { post: any }) {
  if (props.post.model && props.post.model.instagram) {
    const social = props.post.unique ? (
      <div>
        {props.post.count_of_likes ? (
          <span>Likes: {formatLikes(props.post.count_of_likes)}</span>
        ) : null}
        <br />
        {props.post.count_of_comments ? (
          <span>Comments: {formatLikes(props.post.count_of_comments)}</span>
        ) : null}
        <br />
      </div>
    ) : null;

    return (
      <Info>
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href={
            props.post.model && props.post.model.instagram
              ? props.post.model.instagram.profile_url
              : '#'
          }
        >
          {' '}
          {props.post.model.name}
        </Link>
        <br />
        {['story_video', 'story_photo'].includes(props.post.type) ? (
          <span>{formatBigNumber(props.post.model.instagram.number_of_followers)} followers</span>
        ) : (
          social
        )}
      </Info>
    );
  }
  return null;
}

export default SnapshotInfo;
